import { switchMap, takeUntil, tap } from "rxjs/operators";
import { AddEditSiteCategoryComponent } from "./add-edit-site-category/add-edit-site-category.component";
import { Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import {MatDialog as MatDialog,MatDialogConfig as MatDialogConfig } from "@angular/material/dialog";
import {MatPaginator as MatPaginator, PageEvent as PageEvent } from "@angular/material/paginator";
import {MatTableDataSource as MatTableDataSource } from "@angular/material/table";
import { SiteService } from "src/app/new-sites-management/common/services/site.service";
import { CategoryService } from "src/app/e-commerce/common/category/ecommerce-service";

import { PagesService } from "../pages/pages.service";
import { Subject, of } from "rxjs";
import { ECategoryTypes } from "src/app/site-menu/site-menu/common/models/enums";
import { EStatus } from "src/app/models/general-enums";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "app-site-categories",
  templateUrl: "./site-categories.component.html",
  styleUrls: ["./site-categories.component.css"],
})
export class SiteCategoriesComponent implements OnInit, OnDestroy {
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  displayedColumns: string[] = [
    "CategoryName",
    "CategoryType",
    "CategoryCulture",
    "Actions",
  ];
  dataSource = new MatTableDataSource<any>([]);
  categriesType: any[] = [];
  showLoader = false;
  index: number = 0;
  size: number = 10;
  dataLength: number = 0;
  public params: any;
  pageDestroy$ = new Subject();
  allSiteTypes = [];
  typesId = []

  public filterForm = new FormGroup({
    name: new FormControl(null),
    cultureId: new FormControl(""),
    categoryTypeId: new FormControl(""),
  });
  constructor(
    public siteService: SiteService,
    public pagesService: PagesService,
     private snotifyService: ToastrService,
    private dialog: MatDialog,
    private categoryService:CategoryService
  ) {}

  ngOnInit() {
    this.siteService.siteCategories$
      .pipe(takeUntil(this.pageDestroy$))
      .subscribe((res: any) => {
        if(res && res.length) { 
       this.allSiteTypes = res.filter((el) => {
        if(el.id != ECategoryTypes.Product) { 
          this.typesId.push(el.id)
        }
        return el.id != ECategoryTypes.Product
       });

        this.GetCategoriesbySiteId();
        }  
      });

    this.dataSource = new MatTableDataSource([]);
  }

  GetCategoriesbySiteId() {
    // this.params = {
    //   pagination: { start: this.index, number: this.size },
    //   search: {
    //     predicateObject: this.filterForm.value
    //   },
    //   Sort: {}
    // }
    this.params = {
      name: this._name.value,
      cultureId: this._cultureId.value ? +this._cultureId.value : null,
      categoryTypedId: this._categoryTypeId.value
        ? [+this._categoryTypeId.value]
        : this.typesId,
      pagination: {
        pageSize: this.size,
        pageNumber: this.index,
      },
    };
    this.showLoader = true;
    this.siteService.getCategoriesBySiteId(this.params).subscribe((result) => {
      const allCategories = result.data.map((element) => {
        return {
          ...element,
          categoryType: this.getTypeName(element.categoryTypeId),
        };
      });
      


      this.dataSource = new MatTableDataSource<any>(allCategories);
      this.dataLength = result.totalCount;
      this.showLoader = false;
    });
  }

  getTypeName(categoryId) {
    const categoryTypeName = this.allSiteTypes.find((el) => {
      return categoryId == el.id;
    });
    return categoryTypeName && categoryTypeName.name ? categoryTypeName.name : null;
  }

  manageCategory(data?) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.width = "80%";

    dialogConfig.height = "80%";

    
    if (data) {
      dialogConfig.data = data;
    }
    this.dialog
      .open(AddEditSiteCategoryComponent, dialogConfig)
      .afterClosed()
      .subscribe((res) => {
        if (res) this.GetCategoriesbySiteId();
      });
  }

  deleteCategory(element) {
    
    this.categoryService.changeCategoryStatus(element.id , EStatus.Deleted)
      .pipe(
        switchMap((x) => {
          return this.pagesService.getAll();
        })
      )
      .subscribe(
        (res) => {
          this.GetCategoriesbySiteId();
        },
        (err) => {
          this.openNotifyError(err.message || "Something went wrong!!");
        },
        () => this.openNotifySuccess("Deleted successfully")
      );
  }

  applyFilter() {
    this.GetCategoriesbySiteId();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  changePage(event: PageEvent) {
    this.index = event.pageIndex;
    this.size = event.pageSize;
    this.GetCategoriesbySiteId();
  }
  openNotifySuccess(message: string) {
    this.snotifyService.success("", message, {
      timeOut: 2000,
      progressBar: true,
      tapToDismiss: true,
    });
  }
  openNotifyError(message: string) {
    this.snotifyService.error(message, "Something went wrong!!", {
     timeOut: 2000,
      progressBar: true,
      tapToDismiss: true,
    });
  }
  ngOnDestroy(): void {
    this.pageDestroy$.next(true);
  }

  get _name() {
    return this.filterForm.get("name");
  }
  get _categoryTypeId() {
    return this.filterForm.get("categoryTypeId");
  }
  get _cultureId() {
    return this.filterForm.get("cultureId");
  }
}
